import { fetcherThrows, useAuthFetch } from "matsuri-hooks"
import { User } from "../domain/user"
import { m2mUsers_v1 } from "../endpoints/m2m-users.v1"

export const useFindUserById = (token: string, id: string | undefined) => {
    return useAuthFetch<User>(
        token,
        id ? m2mUsers_v1.findUserById({ id }) : null,
        {}
    )
}

/**
 * 複数のユーザーIDをidごとに重複排除した上で1回ずつ取得し、id => Userのマップを返す。
 * 一覧の行ごとにuseFindUserByIdを呼ぶと、同じidが何度も出てくる場合に
 * リクエスト数が行数に比例してしまうため、こちらを使う。
 */
export const useUsersByIds = (token: string, ids: string[]) => {
    const uniqueIds = Array.from(new Set(ids)).sort()
    const key = uniqueIds.length > 0 ? `users:${uniqueIds.join(",")}` : null

    return useAuthFetch<Record<string, User>>(token, key, {
        fetch: async () => {
            const users = await Promise.all(
                uniqueIds.map(id =>
                    fetcherThrows<User>(m2mUsers_v1.findUserById({ id }), {
                        token
                    })
                )
            )
            return Object.fromEntries(
                uniqueIds.map((id, index) => [id, users[index]])
            )
        }
    })
}
